<template>
<div id="meetingPushing">
  <div class="allSearch">
    <div class="newSearch d_flex">
      <div style="width: auto;white-space: normal">
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="调研ID" type="text" style="" v-model="postData.ResearchNo">
        </p>
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="调研名称" type="text" style="" v-model="postData.ResearchName">
        </p>
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="BU" type="text" style="" v-model="postData.Bu">
        </p>
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="产品" type="text" style="" v-model="postData.Product">
        </p>
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="自定义标签" type="text" style="" v-model="postData.CustomTag">
        </p>
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="审批编号" type="text" style="" v-model="postData.auditNo">
        </p>
        <button class="redButton" @click="getList(1)">搜索</button>
        <button class="redButton" @click="addNewSur(1)">新建</button>
      </div>
    </div>
  </div>
  <div style="overflow-x: auto" class="allTablePlace">
    <div>
      <table cellspacing="0" class="allTable">
        <thead>
        <tr>
          <th>调研ID</th>
          <th>调研名称</th>
          <th>BU</th>
          <th>产品</th>
          <th>自定义标签</th>
          <th>审批编号</th>
          <th>创建人</th>
          <th>创建时间</th>
          <th class="t_c">是否显示在武家会议</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr :key="index" v-for="(item, index) in myList">
          <td style="max-width: 200px" class="NoWrap">{{item.researchNo}}</td>
          <td :title="item.researchName" style="max-width: 200px" class="NoWrap">{{item.researchName}}</td>
          <td :title="item.bu" class="NoWrap" style="max-width: 100px">{{item.bu}}</td>
          <td :title="item.product" class="NoWrap" style="max-width: 100px">{{item.product}}</td>
          <td :title="item.customTag" class="NoWrap" style="max-width: 100px">{{item.customTag}}</td>
          <td :title="item.auditNo" class="NoWrap" style="max-width: 100px">{{item.auditNo}}</td>
          <td :title="item.creator" class="NoWrap" style="max-width: 100px">{{item.creator}}</td>
          <td class="NoWrap" style="max-width: 200px">{{item.creationTime}}</td>
          <td class="NoWrap t_c" style="max-width: 200px">
            <input :disabled="userInfo.id !== item.creatorId && !isadmin" @change="changeShowWujia(item.id)" v-model="item.isShowWujiahuiMeeting" class="allSwitch" :id="'switch' + index" type="checkbox">
            <label :for="'switch' + index"></label>
          </td>
          <td width="10%">
            <div class="icon more iconfont icongengduo moreOperations">
              <ul>
                <li v-if="userInfo.id === item.creatorId || isadmin" @click="editSur(item)">编辑</li>
                <li v-if="userInfo.id === item.creatorId || isadmin"  @click="deleteSur(item.id)">删除</li>
                <li  @click="copySur(item.id)">复制</li>
                <li  @click="getQRcode(item.id)">生成链接</li>
                <li  @click="getMeetingInfo(item.id)">三方会议链接</li>
                <!--                  <li @click="exportGroup(item.id, item.name)">导出</li>-->
                <!--                  <li @click="getDominList(1, item)">查看成员</li>-->

              </ul>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <page v-if="totalPage !== 0" v-on:on-getList="getList($event)" :totalCount="totalCount" :totalPage="totalPage" :page="page" :explain="0"></page>
  </div>
  <model v-if="showModel" :buttonType="2" :title="title" :maxHeight="'80vh'" :minWidth="'1200px'" v-on:on-cancel="showModel = false" v-on:on-confirm="showModel = false">
    <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
      <div style="display: inline-block;width: calc(100% - 502px);vertical-align: top">
        <div class="messagePushingStep">
          Step 1.输入调研名称
        </div>
        <div style="justify-content: flex-start" class="d_flex m_t_20">
          <div class="w20 required t_l">调研名称:</div>
          <input v-model="surModel.researchName" class="allInput w60" placeholder="请输入调研名称" type="text" style="">
        </div>
        <div style="margin-top: 20px" class="messagePushingStep">
          Step 2.设置调研标签
        </div>
        <div style="justify-content: flex-start" class="d_flex m_t_20">
          <div class="w20 t_l">BU:</div>
          <allSelect :chooseData="buList" :width="380" style="width: 100%;margin-left: 25px" :needReturn="'id'" :placeholder="'请选择BU'" :matchValue="'name'" :showValue="'{{name}}'" v-model="surModel.bu">
          </allSelect>
<!--          <input v-model="surModel.bu" class="allInput w60" placeholder="请输入BU" type="text" style="">-->
        </div>
        <div style="justify-content: flex-start;margin-top: 20px" class="d_flex">
          <div class="w20 t_l">产品:</div>
          <allSelect :chooseData="prodList" :width="380" style="width: 100%;margin-left: 25px" :needReturn="'id'" :placeholder="'请选择产品'" :matchValue="'name'" :showValue="'{{name}}'" v-model="surModel.product">
          </allSelect>
<!--          <input v-model="surModel.product" class="allInput w60" placeholder="请输入产品" type="text" style="">-->
        </div>
        <div style="justify-content: flex-start;margin-top: 20px" class="d_flex">
          <div class="w20 t_l">自定义标签:</div>
          <input @focus="openTagModal" v-model="surModel.customTag" class="allInput w60" placeholder="请输入自定义标签" type="text" style="">
        </div>
        <div style="justify-content: flex-start;margin-top: 20px" class="d_flex">
          <div class="w20 required t_l">审批编号:</div>
          <input v-model="surModel.auditNo" class="allInput w60" placeholder="请输入审批编号" type="text" style="">
        </div>
        <div style="margin-top: 20px" class="messagePushingStep">
          Step 3.添加/修改问题
        </div>
        <div style="justify-content: flex-start;margin-top: 20px" class="d_flex">
          <div class="w20 required t_l">类型:</div>
          <input @change="changeSubjectType" v-model="questionModel.subjectType" value="单选" type="radio" class="allRadio" id="radio2" name="radio2"/>
          <label for="radio2"></label><abbr>单选题</abbr>
          <input @change="changeSubjectType" v-model="questionModel.subjectType" value="多选" type="radio" class="allRadio" id="radio3" name="radio2"/>
          <label style="margin-left: 20px" for="radio3"></label><abbr>多选题</abbr>
          <input @change="changeSubjectType" v-model="questionModel.subjectType" value="问答" type="radio" class="allRadio" id="radio4" name="radio2"/>
          <label style="margin-left: 20px" for="radio4"></label><abbr>问答题</abbr>
          <input @change="changeSubjectType" v-model="questionModel.subjectType" value="评分" type="radio" class="allRadio" id="radio5" name="radio2"/>
          <label style="margin-left: 20px" for="radio5"></label><abbr>评分题</abbr>
          <input @change="changeSubjectType" v-model="questionModel.subjectType" value="填空" type="radio" class="allRadio" id="radio6" name="radio2"/>
          <label style="margin-left: 20px" for="radio6"></label><abbr>填空题</abbr>
        </div>
        <div v-if="questionModel.subjectType !== '填空'" style="justify-content: flex-start;" class="d_flex m_t_10">
          <div class="w20 required t_l">问题描述:</div>
          <input v-model="questionModel.desc" class="allInput w60" placeholder="请输入问题描述" type="text" style="">
          <span v-if="questionModel.subjectType !== '问答' && questionModel.subjectType !== '评分' && questionModel.subjectType !== '填空' && questionModel.items.length !== 10" @click="addNewItem" class="addSeuItem">+</span>
        </div>
        <div v-if="questionModel.subjectType !== '问答' && questionModel.subjectType !== '填空'">
          <div :key="index" v-for="(item, index) in questionModel.items" style="justify-content: flex-start;" class="d_flex m_t_10">
            <div class="w20 t_l">
              <span v-if="questionModel.setCorrectAnswer">
                 <input @change="changeQustionCorr(index)" :disabled="!questionModel.setCorrectAnswer" v-model="item.correctItem" value="单选" type="checkbox" class="allCheckbox" :id="'questionAns' + index"/>
                 <label :for="'questionAns' + index"></label>
              </span>
              <span v-if="questionModel.subjectType === '评分'" :class="(index === 0 || index === 4) ? 'required' : 'm_l_5'" style="padding-left: 20px">{{ item.itemKey }}</span>
              <span v-else class="required" style="padding-left: 20px">{{ item.itemKey }}</span>
            </div>
            <input v-model="item.itemValue" class="allInput w60" type="text" style="">
            <span @click="redusItem(index)" v-if="index !== 0 && questionModel.subjectType !== '评分'" class="addSeuItem cancel">-</span>
          </div>
          <div v-if="questionModel.subjectType !== '评分'" style="margin-left: 20%;margin-top: 20px;display:flex">

            <div>
              <input @change="changeSetCorrectAnswer" v-model="questionModel.setCorrectAnswer" class="allSwitch" id="setCorrectAnswer" type="checkbox">
              <label for="setCorrectAnswer"></label>
              <label for="setCorrectAnswer">设置正确答案</label>
            </div>
            
            <div style="margin-left:20px" v-if="questionModel.subjectType==='多选'">
              <input @change="changeMaxNumSwitch" v-model="questionModel.maxNumSwitch"  class="allSwitch" id="maxNumSwitch" type="checkbox">
              <label for="maxNumSwitch"></label>
              <label for="maxNumSwitch">设置最大选项数</label>
            </div>

            <allSelect  v-if="questionModel.subjectType==='多选' && questionModel.maxNumSwitch" :chooseData="maxNumList" :width=140  style="margin-left:20px;margin-top:-2px;height:25px" :placeholder="'请选择最多项数'" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" v-model="questionModel.maxNum">
            </allSelect>

          </div>
          <div v-if="questionModel.subjectType !== '评分'" style="margin-left: 20%;margin-top: 10px">
            <Editor placeholder="请输入答案解析" :disabled="!questionModel.setCorrectAnswer" id="tinymce" v-model="questionModel.answerAnalysis" :init="editorInit"></Editor>
<!--            <textarea placeholder="请输入答案解析" name="" style="padding: 5px;width: 75%;" id="" v-model="questionModel.answerAnalysis" :disabled="!questionModel.setCorrectAnswer" class="allTextarea w80" cols="30" rows="10"></textarea>-->
          </div>
        </div>
        <div v-if="questionModel.subjectType === '问答'">
          <div style="justify-content: flex-start;" class="d_flex m_t_10">
            <div class="w20 t_l"></div>
            <input v-model="questionModel.isRequired" class="allSwitch" id="isRequired" type="checkbox">
            <label for="isRequired"></label>
            <label style="margin-left: 10px" for="isRequired">  是否必填</label>
<!--            <textarea name="" style="padding: 5px" id="" disabled class="allTextarea w60" cols="30" rows="10"></textarea>-->
          </div>
        </div>
        <div v-if="questionModel.subjectType === '填空'">
          <div style="justify-content: flex-start;" class="d_flex m_t_10">
            <div class="w20 t_l">
              <span  style="padding-left: 20px">前置描述</span>
            </div>
            <div class="w80">
              <textarea v-model="questionModel.beforeDesc" name="" style="padding: 5px;width: 75%" id="" class="allTextarea w80" cols="30" rows="2"></textarea>
            </div>
            <!--            <textarea name="" style="padding: 5px" id="" disabled class="allTextarea w60" cols="30" rows="10"></textarea>-->
          </div>
          <div style="justify-content: flex-start;" class="d_flex m_t_10">
            <div class="w20 t_l">
              <span  style="padding-left: 20px"></span>
            </div>
            <div>
              <input disabled="disabled" class="allInput w60" type="text" style="">
            </div>
            <!--            <textarea name="" style="padding: 5px" id="" disabled class="allTextarea w60" cols="30" rows="10"></textarea>-->
          </div>
          <div style="justify-content: flex-start;" class="d_flex m_t_10">
            <div class="w20 t_l">
              <span  style="padding-left: 20px">后置描述</span>
            </div>
            <div class="w80">
              <textarea v-model="questionModel.afterDesc" name="" style="padding: 5px;width: 75%" class="allTextarea w80" cols="30" rows="2"></textarea>
            </div>
            <!--            <textarea name="" style="padding: 5px" id="" disabled class="allTextarea w60" cols="30" rows="10"></textarea>-->
          </div>
        </div>
      </div>
      <div style="display: inline-block;width: 500px;vertical-align: top">
        <div style="border-radius: 10px; border: 1px solid #eee;padding: 10px;min-height: 500px;max-height: 500px;overflow: auto">
          <div :key="index" v-for="(item, index) in surModel.subjects" class="d_flex allSelectedMember m_t_10">
            <div @click="editItemIndex(item, index)" style="overflow: hidden;text-overflow: ellipsis" class="w80 t_ov c_p t_l"><span>{{item.subjectType}}</span> <span  style="margin:0 5px">|</span> <span :title="item.subjectType === '填空' ? item.beforeDesc : item.desc">{{ item.subjectType === '填空' ? item.beforeDesc : item.desc }}</span></div>
            <div>
              <span v-if="index !== 0" @click="upQuestionItem(index)" style="transform: rotate(180deg);display: inline-block" class="icon c_p iconfont f_w iconarrow">
              </span>
              <span v-if="index !== surModel.subjects.length - 1" @click="downQuestionItem(index)" class="icon c_p iconfont m_l_10 f_w iconarrow">
              </span>
              <span @click="delQuestionItem(index)" class="icon c_p iconfont m_l_10 f_w iconguanbi">
              </span>
            </div>
          </div>
        </div>
        <div v-show="showPreviewQRModel" style="width:100%; box-sizing:border-box; padding:40px;">
          <div class="split_2" style="display: flex;justify-content: center;">
            <div>
              <img width="100%" :src="pqrmodel.qrCodeData" alt="">
            </div>
          </div>
      </div>
      </div>
      <div class="split_2 m_b_20 m_t_20">
        <div v-if="itemIndex === ''">
          <button @click="pushItem" class="redButtonTwo m_r_10 m_l_10">添加</button>
          <button @click="resetQuestionModel" class="cancelButtonTwo m_r_10 m_l_10">清空</button>
        </div>
        <div v-if="itemIndex !== ''">
          <button @click="editItem" class="redButtonTwo m_r_10 m_l_10">保存</button>
          <button @click="cancelEdit" class="cancelButtonTwo m_r_10 m_l_10">取消</button>
        </div>
        <div class="split2_r">
          <button @click="saveSurAndQRCode" class="redButtonTwo m_r_10 m_l_10">预览</button>
          <button @click="saveSur" class="redButtonTwo m_r_10 m_l_10">确认</button>
          <button @click="showModel = false" class="cancelButtonTwo m_r_10 m_l_10">取消</button>
        </div>
      </div>
    </div>
  </model>
  <model v-if="showQRModel" :buttonType="2" :title="'查看链接'" :maxHeight="'80vh'" :minWidth="'600px'" v-on:on-cancel="showQRModel = false" v-on:on-confirm="showQRModel = false">
    <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
      <div class="split_2">
        <div>
          <img width="90%" :src="qrmodel.qrCodeData" alt="">
        </div>
        <div style="vertical-align: top">
          <div style="word-break: break-all;border-radius: 10px;padding: 10px;background: #eee">
            <div style="word-break: break-all;white-space: normal">{{qrmodel.url}}</div>
            <div @click="copyLink" class="m_t_10 c_p t_r"><input style="position: fixed;top: -9999px" id="surUrl" :value="qrmodel.url" type="text">复制链接 <i style="color: #F25A7F" class="icon iconfont m_l_10 iconneirongguanli"></i></div>
          </div>
        </div>
      </div>
      <div class="m_b_20 m_t_20">
        <div class="t_c">
          <button @click="downLoadQR" class="redButtonTwo m_r_10 m_l_10">下载二维码</button>
          <button @click="showQRModel = false" class="cancelButtonTwo m_r_10 m_l_10">关闭</button>
        </div>
      </div>
    </div>
  </model>
  <!-- 选择标签 -->
    <model v-if="showMeetingEmsQRModel" :buttonType="2" :title="'查看三方会议链接'" :maxHeight="'80vh'" :minWidth="'600px'" v-on:on-cancel="showMeetingEmsQRModel = false" v-on:on-confirm="showMeetingEmsQRModel = false">
    <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
      <div class="split_2 emsDialogCenter">
        <div class="emsQrcodeCenter" v-if="qrmodel.qrCodeData">
          <img  width="90%" :src="qrmodel.qrCodeData" alt="">
        </div>
        <div class="emsQrcodeCenter" v-if="!qrmodel.qrCodeData">只有存在Emscode时才能生成三方会议链接</div>
        <div style="vertical-align: top">
          <div style="word-break: break-all;border-radius: 10px;padding: 10px;background: #eee;">
            <div style="word-break: break-all;white-space: normal">{{qrmodel.url}}</div>
            <div @click="copyLink" class="m_t_10 c_p t_r"><input style="position: fixed;top: -9999px" id="surUrl" :value="qrmodel.url" type="text">复制链接 <i style="color: #F25A7F" class="icon iconfont m_l_10 iconneirongguanli"></i></div>
          </div>
          <div>
            <div>
              <input @keyup.enter="addMeetingInfo" class="allInput m_r_10 " placeholder="Emscode" type="text" style="margin-top: 10px;margin-bottom: 5px;" v-model="emsCode">
              <button class="redButton" @click="addMeetingInfo">添加</button>
            </div>
          <div style="height: 180px;border-radius: 10px;padding: 10px;border: 1px solid #eee;overflow: auto;">
            <div :style="index==selectedEmscodeIdx?'border: 1px solid rgb(238 17 0)':''" class="allSelectedMember" :key="item.id" v-for="(item, index) in meetingInfoList" @click="selectEmsCode(index)">{{item.emsCode}} <b @click.stop="removeSelect(index)">X</b> </div>
          </div>
          </div>
        </div>
      </div>
      <div class="m_b_20 m_t_20">
        <div class="t_c">
          <button @click="downLoadQR" class="redButtonTwo m_r_10 m_l_10">下载二维码</button>
          <button @click="saveMeetingInfo" class="cancelButtonTwo m_r_10 m_l_10">保存并关闭</button>
          <button @click="showMeetingEmsQRModel = false" class="cancelButtonTwo m_r_10 m_l_10">关闭</button>
        </div>
      </div>
    </div>
  </model>
  <!-- 选择标签 -->
  <model v-if="showTagModal" :coverZ="10000" :buttonType="0" :title="'选择标签'" :minWidth="'900px'" v-on:on-cancel="cancelTagModel()" v-on:on-confirm="confirmTagModal()">
    <div style="padding: 10px;width: auto;">
      <!-- 已选择的标签 -->
      <div class="myTag-box">
        <span class="title">已选标签：</span>
        <template v-for="(item, index) in selectedTags" >
            <span class="selected-tags" :style="index == 0 ? 'margin-left: 0;' : ''" :key="index">
              <span style="margin-right: 10px;">{{item.name}}</span>
              <i class="icon iconfont iconguanbi2" style="color: #fff;" @click="cancelSelectedHanlder(item, index)"></i>
            </span>
        </template>
      </div>
      <!-- 所有标签 -->
      <div class="allTag-box">
        <div class="topTag">
          <span :class="{'activedTags-topTag': tagModalData.tabNum == 1, 'tags-topTag': true}" @click="tabNumChange(1)">科室</span>
          <span :class="{'activedTags-topTag': tagModalData.tabNum == 2, 'tags-topTag': true}" @click="tabNumChange(2)">领域</span>
          <span :class="{'activedTags-topTag': tagModalData.tabNum == 3, 'tags-topTag': true}" @click="tabNumChange(3)">适应症</span>
          <span :class="{'activedTags-topTag': tagModalData.tabNum == 4, 'tags-topTag': true}" @click="tabNumChange(4)">自定义标签</span>
        </div>
        <div class="sonTag" :style="tagModalData.tabNum == 1 ? '' : 'border-top-left-radius: 10px;'">
          <div class="searchTag">
            <input class="allInput" type="text" v-model="tagModalData.tagName" style="backgrond-color: #fff;width: 200px;border-radius: 30px;box-sizing: border-box;padding-right: 30px;">
            <i class="icon iconfont iconsousuo" style="color: #ee1100;margin-left: -33px;font-size: 20px!important;"></i>
          </div>
          <div class="tags">
            <!-- 科室 -->
            <div v-if="tagModalData.tabNum == 1">
              <template v-for="item in departmentList">
                  <span
                    :class="{'plain-tags': true, 'checked-tags': item.checked}"
                    :key="item.id"
                    @click="chooseDeparment(item)">
                    {{item.name}}
                  </span>
              </template>
            </div>
            <!-- 领域 -->
            <div v-if="tagModalData.tabNum == 2">
              <template v-for="item in fieldsList">
                  <span
                    :class="{'plain-tags': true, 'checked-tags': item.checked}"
                    :key="item.id"
                    @click="chooseField(item)">
                    {{item.name}}
                  </span>
              </template>
            </div>
            <!-- 适应症 -->
            <div v-if="tagModalData.tabNum == 3">
              <template v-for="item in indicationsList">
                  <span
                    :class="{'plain-tags': true, 'checked-tags': item.checked}"
                    :key="item.id"
                    @click="chooseIndicaton(item)">
                    {{item.name}}
                  </span>
              </template>
            </div>
            <!-- 自定义 -->
            <div v-if="tagModalData.tabNum == 4">
              <template v-for="item in customTagList">
                  <span
                    :class="{'plain-tags': true, 'checked-tags': item.checked}"
                    :key="item.id"
                    @click="chooseCustomeTag(item)">
                    {{item.name}}
                  </span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </model>
</div>
</template>

<script>
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/silver/theme'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/plugins/contextmenu'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/textcolor'
import 'tinymce/icons/default'
import _ from 'lodash'
export default {
  name: 'meetingPushing',
  data () {
    return {
      emsCode: undefined,
      selectedResearchId: 0,
      TempIdForPreview:0,
      selectedEmscodeIdx: 0,
      editorInit: {
        // language_url: process.env.config.baseUrl + '/static/tinymce/zh_CN.js',
        language_url: '/static/tinymce/zh_CN.js',
        language: 'zh_CN',
        // skin_url: process.env.config.baseUrl + '/static/tinymce/skins/ui/oxide',
        skin_url: '/static/tinymce/skins/ui/oxide',
        height: 400,
        plugins: '',
        toolbar:
          'bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | removeformat',
        branding: false
      },
      userInfo: JSON.parse(window.localStorage.getItem('userInfo') || '{}'),
      qrmodel: {
        qrCodeData: '',
        url: ''
      },
      meetingInfoList: [],
      orgMeetingInfoList:[],
      pqrmodel: {
        qrCodeData: '',
        url: ''
      },
      itemIndex: '',
      showModel: false,
      showTagModal: false,
      showQRModel: false,
      showMeetingEmsQRModel: false,
      showPreviewQRModel: false,
      postData: {
        ResearchNo: '',
        AdminOrNot:JSON.parse(window.localStorage.getItem('isAdmin')),
        CurrentUser:JSON.parse(window.localStorage.getItem('userInfo') || '{}').id,
        ResearchName: '',
        Bu: '',
        Product: '',
        CustomTag: '',
        auditNo: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      title: '',
      messageList: [],
      totalPage: 1,
      totalCount: 0,
      page: 1,
      meeting: {},
      myList: [
      ],
      tags: [],
      allTagList: [],
      fieldsList: [],
      selectedTags: [],
      customTagList: [],
      indicationsList: [],
      tagModalData: {
        tagName: '',
        tabNum: 1
      },
      departmentList: [],
      surModel: {
        id: 0,
        tagIds: [],
        researchNo: '',
        researchName: '',
        bu: '',
        product: '',
        customTag: '',
        auditNo: '',
        subjects: [
        ],
        isShowWujiahuiMeeting: true,
        isAdmin: JSON.parse(window.localStorage.getItem('isAdmin')),
      },
      questionModel: {
        desc: '',
        sort: 0,
        answerAnalysis: '',
        beforeDesc: '',
        afterDesc: '',
        setCorrectAnswer: false,
        isRequired: false,
        subjectType: '单选',
        items: [
          {
            itemKey: 'A',
            itemValue: '',
            correctItem: false
          },
          {
            itemKey: 'B',
            itemValue: '',
            correctItem: false
          },
          {
            itemKey: 'C',
            itemValue: '',
            correctItem: false
          },
          {
            itemKey: 'D',
            itemValue: '',
            correctItem: false
          }
        ],
        maxNum:0,
        maxNumSwitch:false
      },
      isadmin: JSON.parse(window.localStorage.getItem('isAdmin')), // 管理员
      questionArray: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      buList: [],
      prodList: [],
      maxNumList:[
          {
            id: 1,
            name: 1
          },
          {
            id: 2,
            name: 2
          },
          {
            id: 3,
            name: 3
          },
          {
            id: 4,
            name: 4
          },
          {
            id: 5,
            name: 5
          },
          {
            id: 6,
            name: 6
          },
          {
            id: 7,
            name: 7
          },
          {
            id: 8,
            name: 8
          },
          {
            id: 9,
            name: 9
          },
          {
            id: 10,
            name: 10
          },
        ]
    }
  },
  created () {
    this.getList(1)
    this.getBuList()
    this.getProdList()
    // 获取所有标签
    this.getTagList()
  },
  components: {
    'Editor': Editor
  },
  mounted () {
    tinymce.init({})
  },
  watch: {
    "tagModalData.tagName" (newData) {
      this.tagModalData.tagName = newData.trim()
      console.log(this.tagModalData.tagName, 'this.tagModalData.tagName')
      for (let i = 0; i < this.selectedTags.length; i++) {
        for (let j = 0; j < this.allTagList.length; j++) {
          if (this.selectedTags[i].id == this.allTagList[j].id) {
            this.allTagList[j].checked = true
          }
        }
      }
      this.customTagList = this.allTagList.filter(val => val.type == 'Defualt')
      this.departmentList = this.allTagList.filter(val => val.type == 'Department')
      this.fieldsList = this.allTagList.filter(val => val.type == 'Field')
      this.indicationsList = this.allTagList.filter(val => val.type == 'Indication')
      if (this.tagModalData.tagName) {
        let str = this.tagModalData.tagName
        if (this.tagModalData.tabNum == 1) {
          let fullList = JSON.parse(JSON.stringify(this.departmentList))
          // 如果是科室tab
          let list = this.departmentList.filter(item => item.name.indexOf(str) > -1)
          console.log(list, '搜索科室')
          this.departmentList = list
        } else if (this.tagModalData.tabNum == 2) {
          // 如果是领域tab
          let list = this.fieldsList.filter(item => item.name.indexOf(str) > -1)
          console.log(list, '搜索领域')
          this.fieldsList = list
        } else if (this.tagModalData.tabNum == 3) {
          // 如果是适应症tab
          let list = this.indicationsList.filter(item => item.name.indexOf(str) > -1)
          console.log(list, '搜索适应症')
          this.indicationsList = list
        } else if (this.tagModalData.tabNum == 4) {
          // 如果是自定义tab
          let list = this.customTagList.filter(item => item.name.indexOf(str) > -1)
          console.log(list, '搜索自定义')
          this.customTagList = list
        }
      } else {
        console.log(this.selectedTags, 'selectedTags')
        // 获取所有标签
        this.getTagList()
        for (let i = 0; i < this.selectedTags.length; i++) {
          for (let j = 0; j < this.allTagList.length; j++) {
            if (this.selectedTags[i].id == this.allTagList[j].id) {
              this.allTagList[j].checked = true
            }
          }
        }
        this.customTagList = this.allTagList.filter(val => val.type == 'Defualt')
        this.departmentList = this.allTagList.filter(val => val.type == 'Department')
        this.fieldsList = this.allTagList.filter(val => val.type == 'Field')
        this.indicationsList = this.allTagList.filter(val => val.type == 'Indication')
      }
    },
    showMeetingEmsQRModel(){
      if(this.meetingInfoList.length>0)
      {
        this.qrmodel.url = this.meetingInfoList[0].url
        this.qrmodel.qrCodeData = this.meetingInfoList[0].qrCodeData
      }else{
        this.qrmodel.url = ''
        this.qrmodel.qrCodeData = undefined
      }
    }
  },
  methods: {
    getBuList () {
      this.$axiox.get('/api/Research/bulist').then(p => {
        for (let i = 0; i < p.length; i++) {
          let data = {
            id: p[i],
            name: p[i]
          }
          this.buList.push(data)
        }
      })
    },
    getProdList () {
      this.$axiox.get('/api/Research/productlist').then(p => {
        for (let i = 0; i < p.length; i++) {
          let data = {
            id: p[i],
            name: p[i]
          }
          this.prodList.push(data)
        }
      })
    },
    // 打开标签弹窗
    openTagModal () {
      if (this.allTagList.length > 0) {
        let arr = this.surModel.tagIds || []
        let articalTags = this.surModel.customTag.split(',')
        console.log(arr)
        for (let i = 0; i < this.allTagList.length; i++) {
          if (arr.length > 0) {
            for (let j = 0; j < arr.length; j++) {
              if (this.allTagList[i].id === arr[j]) {
                this.allTagList[i].checked = true
              }
            }
          } else {
            this.allTagList[i].checked = false
          }
          for (let k = 0; k < articalTags.length; k++) {
            if (this.allTagList[i].name === articalTags[k]) {
              this.allTagList[i].sort = k + 1
            }
          }
        }
        // 选中的tag
        this.selectedTags = this.allTagList.filter(val => val.checked)
        this.customTagList = this.allTagList.filter(val => val.type === 'Defualt')
        this.departmentList = this.allTagList.filter(val => val.type === 'Department')
        this.fieldsList = this.allTagList.filter(val => val.type === 'Field')
        this.indicationsList = this.allTagList.filter(val => val.type === 'Indication')
      } else {
        this.selectedTags = []
        this.customTagList = [] // 自定义
        this.departmentList = [] // 科室
        this.fieldsList = [] // 领域
        this.indicationsList = [] // 适应症
      }
      this.showTagModal = true
    },
    // 确定
    confirmTagModal () {
      this.showTagModal = false
      this.tagModalData.tabNum = 1
      if (this.selectedTags && this.selectedTags.length > 0) {
        // 去重
        this.selectedTags = Array.from(new Set(this.selectedTags))
        let arr = this.selectedTags.map(val => val.name)
        this.surModel.customTag = arr.join(',')
        this.surModel.tagIds = this.selectedTags.map(val => val.id)
      } else {
        this.surModel.customTag = ''
        this.surModel.tagIds = []
      }
    },
    // 取消
    cancelTagModel () {
      this.showTagModal = false
      this.tagModalData.tabNum = 1
      let arr = this.surModel.customTag ? this.surModel.customTag.split(',') : []
      console.log(arr, 'arr')

      for (let i = 0; i < this.departmentList.length; i++) {
        if (arr.length > 0) {
          for (let j = 0; j < arr.length; j++) {
            if (this.departmentList[i].name == arr[j] && this.departmentList[i].sort > -1) {
              this.departmentList[i].checked = true
            }
          }
        } else {
          this.departmentList[i].checked = false
        }
      }

      for (let i = 0; i < this.fieldsList.length; i++) {
        if (arr.length > 0) {
          for (let j = 0; j < arr.length; j++) {
            if (this.fieldsList[i].name == arr[j] && this.fieldsList[i].sort > -1) {
              this.fieldsList[i].checked = true
            }
          }
        } else {
          this.fieldsList[i].checked = false
        }
      }

      for (let i = 0; i < this.indicationsList.length; i++) {
        if (arr.length > 0) {
          for (let j = 0; j < arr.length; j++) {
            if (this.indicationsList[i].name == arr[j] && this.indicationsList[i].sort > -1) {
              this.indicationsList[i].checked = true
            }
          }
        } else {
          this.indicationsList[i].checked = false
        }
      }

      for (let i = 0; i < this.customTagList.length; i++) {
        if (arr.length > 0) {
          for (let j = 0; j < arr.length; j++) {
            if (this.customTagList[i].name == arr[j] && this.customTagList[i].sort > -1) {
              this.customTagList[i].checked = true
            }
          }
        } else {
          this.customTagList[i].checked = false
        }
      }

      if (this.surModel.customTag) {
        let arr1 = this.departmentList.filter(item => item.checked && item.sort > -1)
        let arr2 = this.fieldsList.filter(item => item.checked && item.sort > -1)
        let arr3 = this.indicationsList.filter(item => item.checked && item.sort > -1)
        let arr4 = this.customTagList.filter(item => item.checked && item.sort > -1)
        let selectedArr = [...arr1, ...arr2, ...arr3, ...arr4]
        selectedArr.sort((a, b) => {
          return a.sort - b.sort
        })
        console.log(selectedArr, 'selectedArr')
        // 去重
        this.selectedTags = Array.from(new Set(selectedArr))
        this.surModel.tagIds = this.selectedTags.map(val => val.id)
      } else {
        this.selectedTags = []
        this.surModel.tagIds = []
      }
    },
    // 切换tab
    tabNumChange (num) {
      if (this.tagModalData.tabNum == num) {
        return
      }
      this.tagModalData.tagName = ''
      this.tagModalData.tabNum = num
    },
    // 获取所有标签
    getTagList () {
      let data = {
        // status: 2, // 和全部内容页面传的一样
        name: '',
        department: '',
        fieldId: '',
        indicationId: '',
        userID: this.userInfo.id,
        isOnlyParent: false,
        isadmin: this.isadmin,
        type: 0 // Defualt=1,// 普通标签; Department=2,//科室; Indication=3,//适应症; Field=4,//领域; 0=所有
      }
      console.log(data, 'data')
      let params = {
        pageIndex: 1,
        pageSize: 9999
      }
      let url = this.$commonJs.returnQuery('/api/Article/QueryArticleTag', data)
      this.$axiox.post(url, params).then(res => {
        console.log(res, '获取标签列表')
        if (res.data && res.data.length > 0) {
          this.allTagList = res.data.map(val => {
            return {
              checked: false,
              sort: -1, // 用于排序
              ...val
            }
          })
          // this.customTagList = this.allTagList.filter(val => val.type == 'Defualt')
          // this.departmentList = this.allTagList.filter(val => val.type == 'Department')
          // this.fieldsList = this.allTagList.filter(val => val.type == 'Field')
          // this.indicationsList = this.allTagList.filter(val => val.type == 'Indication')
        } else {
          this.allTagList = []
          // this.customTagList = [] // 自定义
          // this.departmentList = [] //科室
          // this.fieldsList = [] // 领域
          // this.indicationsList = [] // 适应症
        }
      })
    },
    // 选择科室
    chooseDeparment (item) {
      console.log(item, 'chooseDeparment')
      item.checked = !item.checked
      if (item.checked) {
        this.selectedTags.push(item)
      } else {
        let index = this.selectedTags.findIndex(val => val.name == item.name)
        this.selectedTags.splice(index, 1)
      }
      this.selectedTags.forEach((val, idx) => val.sort = idx)
      console.log(this.selectedTags, 'this.selectedTags')
    },
    // 选择领域
    chooseField (item) {
      console.log(item, 'chooseField')
      item.checked = !item.checked
      if (item.checked) {
        this.selectedTags.push(item)
      } else {
        let index = this.selectedTags.findIndex(val => val.name == item.name)
        this.selectedTags.splice(index, 1)
      }
      this.selectedTags.forEach((val, idx) => val.sort = idx)
      console.log(this.selectedTags, 'this.selectedTags')
    },
    // 选择适应症
    chooseIndicaton (item) {
      console.log(item, 'chooseIndicaton')
      item.checked = !item.checked
      if (item.checked) {
        this.selectedTags.push(item)
      } else {
        let index = this.selectedTags.findIndex(val => val.name == item.name)
        this.selectedTags.splice(index, 1)
      }
      this.selectedTags.forEach((val, idx) => val.sort = idx)
      console.log(this.selectedTags, 'this.selectedTags')
    },
    // 选择自定义
    chooseCustomeTag (item) {
      console.log(item, 'chooseCustomeTag')
      item.checked = !item.checked
      if (item.checked) {
        this.selectedTags.push(item)
      } else {
        let index = this.selectedTags.findIndex(val => val.name == item.name)
        this.selectedTags.splice(index, 1)
      }
      this.selectedTags.forEach((val, idx) => val.sort = idx)
      console.log(this.selectedTags, 'this.selectedTags')
    },
    // 取消已选择
    cancelSelectedHanlder (item, index) {
      this.selectedTags.splice(index, 1)
      if (item.type == 'Department') {
        for (let i = 0; i < this.departmentList.length; i++) {
          if (item.name == this.departmentList[i].name) {
            item.checked = false
          }
        }
      } else if (item.type == 'Field') {
        for (let i = 0; i < this.fieldsList.length; i++) {
          if (item.name == this.fieldsList[i].name) {
            item.checked = false
          }
        }
      } else if (item.type == 'Indication') {
        for (let i = 0; i < this.indicationsList.length; i++) {
          if (item.name == this.indicationsList[i].name) {
            item.checked = false
          }
        }
      } else if (item.type == 'Defualt') {
        for (let i = 0; i < this.customTagList.length; i++) {
          if (item.name == this.customTagList[i].name) {
            item.checked = false
          }
        }
      }
    },
    changeSubjectType () {
      if (this.questionModel.subjectType === '评分') {
        this.questionModel = {
          desc: this.questionModel.desc,
          sort: this.questionModel.sort,
          answerAnalysis: '',
          beforeDesc: '',
          afterDesc: '',
          setCorrectAnswer: false,
          isRequired: false,
          subjectType: '评分',
          items: [
            {
              itemKey: '1',
              itemValue: '',
              correctItem: false
            },
            {
              itemKey: '2',
              itemValue: '',
              correctItem: false
            },
            {
              itemKey: '3',
              itemValue: '',
              correctItem: false
            },
            {
              itemKey: '4',
              itemValue: '',
              correctItem: false
            },
            {
              itemKey: '5',
              itemValue: '',
              correctItem: false
            }
          ]
        }
      }
      if ((this.questionModel.subjectType === '单选' || this.questionModel.subjectType === '多选') && this.questionModel.items[0].itemKey === '1') {
        this.questionModel = {
          desc: this.questionModel.desc,
          sort: this.questionModel.sort,
          subjectType: this.questionModel.subjectType,
          maxNum:this.questionModel.maxNum,
          maxNumSwitch:this.questionModel.maxNumSwitch,
          answerAnalysis: '',
          beforeDesc: '',
          afterDesc: '',
          setCorrectAnswer: false,
          isRequired: false,
          items: [
            {
              itemKey: 'A',
              itemValue: '',
              correctItem: false
            },
            {
              itemKey: 'B',
              itemValue: '',
              correctItem: false
            },
            {
              itemKey: 'C',
              itemValue: '',
              correctItem: false
            },
            {
              itemKey: 'D',
              itemValue: '',
              correctItem: false
            }
          ]
        }
      }
    },
    cancelEdit () {
      this.itemIndex = ''
      this.resetQuestionModel()
    },
    copyLink () {
      let Url2 = document.getElementById('surUrl')
      Url2.select() // 选择对象
      document.execCommand('Copy')
    },
    base64ToBlob (code) {
      let parts = code.split(';base64,')
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length
      let uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], {type: contentType})
    },
    downLoadQR () {
      let aLink = document.createElement('a')
      let blob = this.base64ToBlob(this.qrmodel.qrCodeData)
      let evt = document.createEvent('HTMLEvents')
      evt.initEvent('click', true, true)
      aLink.download = '会议二维码'
      aLink.href = URL.createObjectURL(blob)
      aLink.click()
    },
    copySur (id) {
      this.$axiox.get('/api/Research/detail/' + id).then(p => {
        p.id = 0
        this.surModel = p
        this.showModel = true
        this.title = '复制调研'
      })
    },
    getQRcode (id) {
      this.$axiox.get('/api/Research/qrcode?id=' + id + '&type=0').then(p => {
        this.showQRModel = true
        this.qrmodel = p
      })
    },
    addMeetingInfo () {
      if(this.emsCode){
        if(this.meetingInfoList.findIndex(x=>x.emsCode === this.emsCode)<0) {
          let meetingInfo = new Object();
          meetingInfo.researchId = this.selectedResearchId
          meetingInfo.emsCode = this.emsCode
          // 生成第三方二维码，url
          this.$axiox.get('/api/Research/emsqrcode?id=' + this.selectedResearchId + '&type=0&meetingEmscode=' + this.emsCode).then(p => {
            meetingInfo.url = p.url
            meetingInfo.qrCodeData = p.qrCodeData
            this.emsCode = undefined
            console.log('meetingInfo',meetingInfo)
            this.meetingInfoList.push(meetingInfo)
            if(this.meetingInfoList.length>0 && this.qrmodel.url === '')
              {
                this.qrmodel.url = this.meetingInfoList[0].url
                this.qrmodel.qrCodeData = this.meetingInfoList[0].qrCodeData
              }
            console.log('this.qrmodel',this.qrmodel)  
          })
        }
        else{
            return this.$commonJs.alertTips({
              type: 'warning',
              title: '提示',
              content: '当前Emscode已存在',
              stayTime: 5
            })
        }
      }
    },
    getMeetingInfo (id) {
      this.selectedResearchId = id
      this.$axiox.get('/api/Research/getmeetinginfo?id=' + id).then(p => {
        this.showMeetingEmsQRModel = true
        this.meetingInfoList = p
        this.orgMeetingInfoList = _.cloneDeep(this.meetingInfoList)
      })
    },
    saveMeetingInfo () {
      if(this.compMeetingInfoList())
      {
        let data = {
          id : this.selectedResearchId,
          researchMeetingInfoList : this.meetingInfoList
        }
        this.$axiox.post('/api/Research/savemeetinginfo', data).then(p => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '提示',
            content: '渠道信息保存成功',
            stayTime: 5
          })
          this.emsCode = undefined
          this.selectedEmscodeIdx = 0
          this.showMeetingEmsQRModel = false
          }
        )
      }
      else
      {
          this.emsCode = undefined
          this.selectedEmscodeIdx = 0
          this.showMeetingEmsQRModel = false
      }
    },
    compMeetingInfoList()
    {
      if(this.orgMeetingInfoList.length !== this.meetingInfoList.length)
      {
        return true
      }
      else
      {
        let orgList = this.orgMeetingInfoList.sort((a,b)=>{return a.emsCode.localeCompare(b.emsCode)})
        let editList = this.meetingInfoList.sort((a,b)=>{return a.emsCode.localeCompare(b.emsCode)})
        for(let i=0;i<orgList.length;i++){
          if(orgList[i].emsCode !== editList[i].emsCode)
          {
            return true
          }
        }
        return false
      }
    }
    ,
    selectEmsCode(idx){
      this.selectedEmscodeIdx = idx
      this.qrmodel.url = this.meetingInfoList[idx].url
      this.qrmodel.qrCodeData = this.meetingInfoList[idx].qrCodeData
    },
    removeSelect (idx) {
      if(this.qrmodel.url = this.meetingInfoList[idx].url)
      {
        this.meetingInfoList.splice(idx,1)
        this.selectedEmscodeIdx = 0
        if(this.meetingInfoList.length>0){
          this.qrmodel.url = this.meetingInfoList[0].url
          this.qrmodel.qrCodeData = this.meetingInfoList[0].qrCodeData
        }
        else{
          this.qrmodel.url = ''
          this.qrmodel.qrCodeData = undefined
        }
      }
    },
    deleteSur (id) {
      this.$commonJs.doubleComfirm({
        content: '是否确定删除此调研？',
        successFun: msg => {
          this.$axiox.get('/api/Research/del/' + id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getList(1)
          })
        },
        errorFun: msg => {
        }
      })
    },
    changeSetCorrectAnswer () {
      if (!this.questionModel.setCorrectAnswer) {
        this.questionModel.answerAnalysis = ''
        for (let i = 0; i < this.questionModel.items.length; i++) {
          this.questionModel.items[i].correctItem = false
        }
      }
    },
    changeMaxNumSwitch () {
      //console.log("this.questionModel.maxNumSwitch-------Before---------"+this.questionModel.maxNumSwitch)
      //console.log("this.questionModel.maxNum-------Before---------"+this.questionModel.maxNum)
      if(!this.questionModel.maxNumSwitch){
        this.questionModel.maxNum=0
      }
      //console.log("this.questionModel.maxNumSwitch-------after---------"+this.questionModel.maxNumSwitch)
      //console.log("this.questionModel.maxNum-------after---------"+this.questionModel.maxNum)
    },
    changeQustionCorr (index) {
      if (this.questionModel.subjectType === '单选') {
        for (let i = 0; i < this.questionModel.items.length; i++) {
          if (index !== i) {
            this.questionModel.items[i].correctItem = false
          }
        }
      }
    },
    changeShowWujia (id) {
      this.$axiox.get('/api/Research/switch/wujiaMeeting?id=' + id).then(p => {
      })
    },
    editSur (item) {
      this.$axiox.get('/api/Research/detail/' + item.id).then(p => {
        this.surModel = JSON.parse(JSON.stringify(p))
        this.showModel = true
        this.title = '编辑调研'
        this.TempIdForPreview=this.surModel.id;
      })
    },
    editItemIndex (item, index) {
      this.itemIndex = index
      this.questionModel = JSON.parse(JSON.stringify(item))
      if (item.subjectType === '问答' || item.subjectType === '填空') {
        this.questionModel = {
          desc: JSON.parse(JSON.stringify(item.desc)),
          sort: item.sort,
          subjectType: item.subjectType,
          answerAnalysis: '',
          beforeDesc: JSON.parse(JSON.stringify(item.beforeDesc)),
          afterDesc: JSON.parse(JSON.stringify(item.afterDesc)),
          setCorrectAnswer: false,
          isRequired: JSON.parse(JSON.stringify(item.isRequired)),
          items: [
            {
              itemKey: 'A',
              itemValue: '',
              correctItem: false
            },
            {
              itemKey: 'B',
              itemValue: '',
              correctItem: false
            },
            {
              itemKey: 'C',
              itemValue: '',
              correctItem: false
            },
            {
              itemKey: 'D',
              itemValue: '',
              correctItem: false
            }
          ]
        }
      }
      if (item.subjectType === '评分') {
        this.questionModel = {
          desc: JSON.parse(JSON.stringify(item.desc)),
          sort: item.sort,
          answerAnalysis: '',
          setCorrectAnswer: false,
          isRequired: false,
          subjectType: '评分',
          items: JSON.parse(JSON.stringify(item.items))
        }
      }
    },
    upQuestionItem (index) {
      let data = JSON.parse(JSON.stringify(this.surModel.subjects[index - 1]))
      let data2 = JSON.parse(JSON.stringify(this.surModel.subjects[index]))
      this.surModel.subjects[index] = data
      this.surModel.subjects[index - 1] = data2
      this.resetItemSort()
      this.$forceUpdate()
    },
    downQuestionItem (index) {
      let data = JSON.parse(JSON.stringify(this.surModel.subjects[index + 1]))
      let data2 = JSON.parse(JSON.stringify(this.surModel.subjects[index]))
      this.surModel.subjects[index] = data
      this.surModel.subjects[index + 1] = data2
      this.resetItemSort()
      this.$forceUpdate()
    },
    delQuestionItem (index) {
      this.surModel.subjects.splice(index, 1)
      this.resetItemSort()
    },
    resetQuestionModel () {
      this.questionModel = {
        desc: '',
        sort: 0,
        subjectType: '单选',
        answerAnalysis: '',
        beforeDesc: '',
        afterDesc: '',
        setCorrectAnswer: false,
        isRequired: false,
        items: [
          {
            itemKey: 'A',
            itemValue: '',
            correctItem: false
          },
          {
            itemKey: 'B',
            itemValue: '',
            correctItem: false
          },
          {
            itemKey: 'C',
            itemValue: '',
            correctItem: false
          },
          {
            itemKey: 'D',
            itemValue: '',
            correctItem: false
          }
        ],
        maxNum:0,
        maxNumSwitch:false
      }
    },
    editItem () {
      if (!this.questionModel.desc && this.questionModel.subjectType !== '填空') {
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '请输入问题描述',
          stayTime: 5
        })
      }
      if (this.questionModel.subjectType !== '问答' && this.questionModel.subjectType !== '评分' && this.questionModel.subjectType !== '填空') {
        for (let i = 0; i < this.questionModel.items.length; i++) {
          if (!this.questionModel.items[i].itemValue) {
            return this.$commonJs.alertTips({
              type: 'warning',
              title: '提示',
              content: '请输入选项描述',
              stayTime: 5
            })
          }
        }
        if (this.questionModel.setCorrectAnswer) {
          let num = 0
          for (let i = 0; i < this.questionModel.items.length; i++) {
            if (this.questionModel.items[i].correctItem) {
              num++
            }
          }
          if (num === 0) {
            return this.$commonJs.alertTips({
              type: 'warning',
              title: '提示',
              content: '请设置一个正确答案',
              stayTime: 5
            })
          }
          if (!this.questionModel.answerAnalysis) {
            return this.$commonJs.alertTips({
              type: 'warning',
              title: '提示',
              content: '请输入答案解析',
              stayTime: 5
            })
          }
        }
      }
      if (this.questionModel.subjectType === '评分') {
        for (let i = 0; i < this.questionModel.items.length; i++) {
          if ((i === 0 || i === 4) && !this.questionModel.items[i].itemValue) {
            return this.$commonJs.alertTips({
              type: 'warning',
              title: '提示',
              content: '请输入选项描述',
              stayTime: 5
            })
          }
        }
      }
      if (this.questionModel.subjectType === '填空' && !this.questionModel.beforeDesc && !this.questionModel.afterDesc) {
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '前置描述和后置描述必须输入一个',
          stayTime: 5
        })
      }
      if(this.questionModel.subjectType === '多选' && !this.questionModel.maxNum && this.questionModel.maxNumSwitch){
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '请选择最多项数',
          stayTime: 5
        })
      }
      if(this.questionModel.subjectType === '多选' && (this.questionModel.maxNum>this.questionModel.items.length) && this.questionModel.maxNumSwitch){
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '最多项数不可大于选项总数',
          stayTime: 5
        })
      }       
      if(!(this.questionModel.subjectType === '多选')){
        this.questionModel.maxNum=0
        this.questionModel.maxNumSwitch=false
      }
      this.surModel.subjects[this.itemIndex] = JSON.parse(JSON.stringify(this.questionModel))
      this.itemIndex = ''
      this.resetQuestionModel()
    },
    pushItem () {
      if (!this.questionModel.desc && this.questionModel.subjectType !== '填空') {
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '请输入问题描述',
          stayTime: 5
        })
      }
      if (this.questionModel.subjectType !== '问答' && this.questionModel.subjectType !== '评分' && this.questionModel.subjectType !== '填空') {
        for (let i = 0; i < this.questionModel.items.length; i++) {
          if (!this.questionModel.items[i].itemValue) {
            return this.$commonJs.alertTips({
              type: 'warning',
              title: '提示',
              content: '请输入选项描述',
              stayTime: 5
            })
          }
        }
        if (this.questionModel.setCorrectAnswer) {
          let num = 0
          for (let i = 0; i < this.questionModel.items.length; i++) {
            if (this.questionModel.items[i].correctItem) {
              num++
            }
          }
          if (num === 0) {
            return this.$commonJs.alertTips({
              type: 'warning',
              title: '提示',
              content: '请设置一个正确答案',
              stayTime: 5
            })
          }
          if (!this.questionModel.answerAnalysis) {
            return this.$commonJs.alertTips({
              type: 'warning',
              title: '提示',
              content: '请输入答案解析',
              stayTime: 5
            })
          }
        }
      }
      if (this.questionModel.subjectType === '评分') {
        for (let i = 0; i < this.questionModel.items.length; i++) {
          if ((i === 0 || i === 4) && !this.questionModel.items[i].itemValue) {
            return this.$commonJs.alertTips({
              type: 'warning',
              title: '提示',
              content: '请输入选项描述',
              stayTime: 5
            })
          }
        }
      }
      if (this.questionModel.subjectType === '填空' && !this.questionModel.beforeDesc && !this.questionModel.afterDesc) {
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '前置描述和后置描述必须输入一个',
          stayTime: 5
        })
      }
      if(this.questionModel.subjectType === '多选' && !this.questionModel.maxNum && this.questionModel.maxNumSwitch){
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '请选择最多项数',
          stayTime: 5
        })
      }
      if(this.questionModel.subjectType === '多选' && (this.questionModel.maxNum>this.questionModel.items.length) && this.questionModel.maxNumSwitch){
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '最多项数不可大于选项总数',
          stayTime: 5
        })
      }       
      if(!(this.questionModel.subjectType === '多选')){
        this.questionModel.maxNum=0
        this.questionModel.maxNumSwitch=false
      }
      this.surModel.subjects.push(JSON.parse(JSON.stringify(this.questionModel)))
      this.resetItemSort()
      this.resetQuestionModel()
    },
    resetItemSort () {
      for (let i = 0; i < this.surModel.subjects.length; i++) {
        this.surModel.subjects[i].sort = i
      }
    },
    redusItem (index) {
      this.questionModel.items.splice(index, 1)
      for (let i = 0; i < this.questionModel.items.length; i++) {
        this.questionModel.items[i].itemKey = this.questionArray[i]
      }
    },
    addNewItem () {
      if (this.questionModel.items.length < 10) {
        let data = {
          itemKey: this.questionArray[this.questionModel.items.length],
          itemValue: ''
        }
        this.questionModel.items.push(data)
      } else {
        this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '题目最多添加10个选项',
          stayTime: 5
        })
      }
    },
    addNewSur () {
      this.title = '新建调研'
      this.showModel = true
      this.resetQuestionModel()
      this.surModel = {
        id: 0,
        tagIds: [],
        researchNo: '',
        researchName: '',
        bu: '',
        product: '',
        customTag: '',
        auditNo: '',
        subjects: [
        ],
        isShowWujiahuiMeeting: true,
        isAdmin: this.isadmin
      }
    },
    saveSurAndQRCode () {
      // this.$axiox.get('/api/Research/qrcode?id=' + 265 + '&type=0').then(p => {
      //   this.showPreviewQRModel = true
      //   this.pqrmodel = p
      // })
      if (!this.surModel.researchName) {
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '请输入调研名称',
          stayTime: 5
        })
      }
      if (!this.surModel.auditNo) {
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '请输入审批编号',
          stayTime: 5
        })
      }
      if (this.surModel.subjects.length === 0) {
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '未添加问题',
          stayTime: 5
        })
      }
      let url = '/api/Research/createReview'
      // let content = '创建成功'
      // if (this.surModel.id !== 0) {
      //   url = '/api/Research/edit'
      //   content = '编辑成功'
      // }
      this.surModel.isAdmin = this.isadmin
       if (this.surModel.id !== 0) {
       this.surModel.id = 0
      }
      this.$axiox.post(url, this.surModel).then(p => {
        this.showPreviewQRModel = true
        this.pqrmodel = p
        // this.$commonJs.alertTips({
        //   type: 'success',
        //   title: '提示',
        //   content: content,
        //   stayTime: 5
        // })
        // this.getList(1)
        // this.showModel = false
      })
    },
    saveSur () {
      console.log("[[[[[[[[[[[[[[[[[[[[[[]]]]]]]]]]]]]]]]]]]]]]"+this.surModel.id)
      if (!this.surModel.researchName) {
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '请输入调研名称',
          stayTime: 5
        })
      }
      if (!this.surModel.auditNo) {
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '请输入审批编号',
          stayTime: 5
        })
      }
      if (this.surModel.subjects.length === 0) {
        return this.$commonJs.alertTips({
          type: 'warning',
          title: '提示',
          content: '未添加问题',
          stayTime: 5
        })
      }
      let url = '/api/Research/create'
      let content = '创建成功'
      if (this.surModel.id !== 0) {
        url = '/api/Research/edit'
        content = '编辑成功'
      }
      this.surModel.isAdmin = this.isadmin
      this.$axiox.post(url, this.surModel).then(p => {
        console.log("<<<<<<<<<<<<<"+p)
        if(p=="Exception"){
          this.surModel.id=this.TempIdForPreview;
          url = '/api/Research/edit'
          content = '编辑成功'

          this.$axiox.post(url, this.surModel).then(p => {

            })

        }

        this.$commonJs.alertTips({
          type: 'success',
          title: '提示',
          content: content,
          stayTime: 5
        })
        this.getList(1)
        this.showModel = false
      })
    },
    getDetail (item) {
      this.meeting = item
      this.showModel = true
    },
    getList (pageIndex) {
      // console.log("this.isadmin------------------------------------"+this.isadmin)
      // console.log("CurrentUser:------------------------------------"+this.userInfo.id)
      let data = JSON.parse(JSON.stringify(this.postData))
      data.PageIndex = pageIndex
      let url = this.$commonJs.returnQuery('/api/Research/list', data)
      this.$axiox.getList(url).then(msg => {
        this.myList = msg.data
        this.postData.PageIndex = pageIndex
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    }
  }
}
</script>

<style scoped>
.allSelectedMember{
  padding: 10px 20px;
  border-radius: 10px;
  background: #FEF5F0;
  margin: 10px 0;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.allSelectedMember b{
  position: absolute;
  right: 10px;
  cursor: pointer;
}
.myTag-box {
  border: 1px solid #ee1100;
  border-radius: 10px;
  min-height: 100px;
  overflow: auto;
  max-height: 150px;
}
.myTag-box .title {
  font-size: 14px;
  color: rgb(137,137,137);
  display: inline-block;
  float: left;
  width: 10%;
  padding: 5px 0;
  margin-top: 10px;
  text-align: center;
}
.myTag-box .selected-tags {
  width: auto;
  text-align: center;
  display: inline-block;
  color: #fff;
  background-color: #ee1100;
  border-radius: 30px;
  float: left;
  padding: 5px 15px;
  margin: 10px;
  cursor: pointer;
  box-shadow: 0px 2px 6px -2px rgba(255, 0, 0, 0.6);
  box-sizing: border-box;
  padding-right: 8px;
}
.myTag-box .selected-tags:first-child {
  margin-left: 0!important;
}
.tags-topTag {
  text-align: center;
  width: 120px;
  padding: 5px 0;
  display: inline-block;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #ffffff;
  color: #333;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
.activedTags-topTag {
  background-color: #FFF2EC;
  color: #ee1100;
  box-shadow: 0px -5px 9px -3px rgba(76,73,72, 0.1);
}
.allTag-box {
  margin-top: 15px;
}
.sonTag {
  border-radius: 0 10px 10px 10px;
  background-color: #FFF2EC;
  min-height: 200px;
  overflow: hidden;
  /* padding: 0 6px; */
  box-sizing: border-box;
  box-shadow: 0px 8px 6px -3px rgba(76,73,72, 0.1);
}
.searchTag {
  margin-top: 10px;
  padding-left: 10px;
  margin-bottom: 10px;
}
.plain-tags {
  width: auto;
  /* width: 10%; */
  /* height: 26px; */
  /* line-height: 30px; */
  text-align: center;
  display: inline-block;
  border: 1px solid rgb(76,73,72);
  color: rgb(76,73,72);
  border-radius: 30px;
  float: left;
  padding: 5px 15px;
  margin: 10px;
  cursor: pointer;
  box-shadow: 0px 2px 6px -2px rgba(76,73,72, 0.6);
  box-sizing: border-box;
}
.checked-tags {
  border: 1px solid #ee1100!important;
  color: #ee1100!important;
  box-shadow: 0px 2px 6px -2px rgba(255, 0, 0, 0.6);
}

.emsDialogCenter {
  display: flex;
  align-items: stretch;
}

.emsQrcodeCenter {
  display: flex;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/surveryManager/surveryList.vue